import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import styles from './FilterModal.module.css';

interface FilterModalProps {
  children: React.ReactNode;
  onApply: () => void;
  onClear: () => void;
  onHide: () => void;
  show: boolean;
}

const FilterModal = ({
  children,
  onApply,
  onClear,
  onHide,
  show,
}: FilterModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      fullscreen="lg-down"
      onHide={onHide}
      show={show}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('filters')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.body}>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.footer}>
          <Button
            className={styles.footerButton}
            onClick={onClear}
            variant="outline-secondary"
          >
            {t('clearFilters')}
          </Button>
          <Button
            className={styles.footerButton}
            onClick={onApply}
            variant="primary"
          >
            {t('applyFilters')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;
